import {
	Box,
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
	Stack,
	Text,
	Textarea,
	useToast,
} from '@chakra-ui/react';

import { crearActividad, updateActividad } from '../../../services/actividades';
import {
	errorNotification,
	okNotification,
} from '../../../utils/Notificaciones';
import EasyDatePickerWithTime from '../../EasyDatePicker/EasyDatePickerWithTime';
import { useState } from 'react';
// import { createEvent } from '../../../services/agenda';
// import { TIPOS_CITAS } from '../../../data/constants';

const PromocionProcesoGuiado = ({ isOpen, onClose, onClosePadre, datos }) => {
	const toast = useToast();
	const [crearCita, setCrearCita] = useState(false);
	const [fechaInicio, setFechaInicio] = useState(new Date());
	const [comentario, setComentario] = useState('');

	const handleSubmit = async e => {
		e.preventDefault();
		try {
			if (crearCita) {
				let actividadPromocion = null;
				if (datos.actividadUuid) {
					actividadPromocion = await updateActividad(
						datos.actividadUuid,
						datos,
					);
				} else {
					actividadPromocion = await crearActividad(datos);
				}

				/*
				const test = await createEvent({
					entidad_relacionada: 'Inmueble',
					fechaInicio: fechaInicio || new Date(),
					fechaFin: new Date(new Date().getTime() + 30 * 60000),
					estado: 'Programada',
					tipo: 'Venta o alquiler',
					descripcion: datos.descripcion,
					color: TIPOS_CITAS.find(tipo => tipo.tipo === 'Venta o alquiler')
						.color,
					responsableUuid: datos.responsableUuid,
					clienteUuid: datos.clienteUuid,
					inmuebleUuid: datos.inmuebleUuid,
					actividadeUuid: actividadPromocion.uuid,
				});

				// TODO: ¿Crear actividad de cita de venta?
				console.log("🚀 ~ handleSubmit ~ test:", test)
				*/

				if (actividadPromocion)
					okNotification(
						'Actividad creada. Crea la cita manualmente desde actividades.',
						toast,
					);
			} else {
				if (datos.actividadUuid) {
					await updateActividad(datos.actividadUuid, datos);
				} else {
					await crearActividad(datos);
				}

				okNotification('Actividad creada.', toast);
			}
		} catch (error) {
			console.log('🚀 ~ handleSubmit ~ error:', error);
			errorNotification('Error al crear la actividad', toast);
		}
		onClose();
		onClosePadre();
		//window.location.reload();
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} size='6xl'>
			<ModalOverlay bgColor='blackAlpha.800' />
			<ModalContent>
				<ModalHeader>Proceso guiado</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack direction='column'>
						<Text textAlign='center'>
							¿Quieres hacer una cita de venta?
						</Text>
						<Select
							placeholder='¿Quieres hacer una cita de venta?'
							onChange={e =>
								setCrearCita(e.target.value === 'true')
							}
							value={crearCita ? 'true' : 'false'}
						>
							<option value='true'>Sí</option>
							<option value='false'>No</option>
						</Select>

						{crearCita && (
							<Stack direction='column'>
								<Box>
									<Text textAlign='center'>
										Fecha de inicio
									</Text>
									<EasyDatePickerWithTime
										name='fecha_inicio'
										value={fechaInicio}
										handleChange={e => setFechaInicio(e)}
									/>
								</Box>
								<Text textAlign={'center'}>Comentario</Text>
								<Textarea
									value={comentario}
									onChange={e =>
										setComentario(e.target.value)
									}
									minH='90px'
								/>
							</Stack>
						)}

						<Button
							colorScheme='blue'
							size='sm'
							mt={4}
							onClick={handleSubmit}
							isDisabled={
								crearCita && (!fechaInicio || !comentario)
							}
						>
							Guardar
						</Button>
					</Stack>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default PromocionProcesoGuiado;
